import ApiService from '../api.service';

const Principals = {
  login: params => ApiService.post('/api/v1/principals/sign_in', params),
  validate: params => ApiService.post('/api/v1/principals/validate_principal_register', params),
  recoverPassword: params => ApiService.post('/api/v1/principals/recover_password', params),
  update: params => ApiService.put('/api/v1/principals/me', params),
  find: params => ApiService.query('/api/v1/principals/find_principal_register', params),
  show: () => ApiService.get('/api/v1/principals/me'),
  register: params => ApiService.post('/api/v1/principals', params),
  newPassword: params => ApiService.post('/api/v1/new_password', params),
  verifyRecoveryToken: params => ApiService.post('/api/v1/valid_token', params),
  deleteAccount: () => ApiService.delete('api/v1/principals/me'),
};

export default Principals;
